// ProtectedRoute — gate authed app routes via Clerk's signed-in state.
//
// Wraps each protected page so unauthed deep-links redirect to /auth/sign-in
// instead of relying on silent-throw behavior (FE-M-4 R1 D01 P0 fix).
//
// PAGE_STATES.md flagged this gap explicitly: 6 routes (/dashboard,
// /onboarding, /sessions/:id/live, /sessions/:id/report, /account,
// /billing/success) need an explicit gate.
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import LoadingState from '@/ui/molecules/LoadingState';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isSignedIn, isLoaded } = useClerkAuth();
  const location = useLocation();

  if (!isLoaded) {
    return <LoadingState label="" />;
  }

  if (!isSignedIn) {
    const redirectTo = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/auth/sign-in?redirect=${encodeURIComponent(redirectTo)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
